import {
    ERROR_INSUFFICIENT_LEVEL,
    ERROR_LACK_OF_COINS,
    ERROR_LACK_OF_ENERGY,
    ERROR_LACK_OF_MATERIA,
    ERROR_NEED_SURROUND
} from "./constants.js";


export const errors = {
    [ERROR_LACK_OF_ENERGY]: {
        title: 'Not enough energy',
        template: '#depositEnergy'
    },
    [ERROR_LACK_OF_MATERIA]: {
        title: 'Oops. Not enough materia!',
        template: '#depositMateria'
    },
    [ERROR_LACK_OF_COINS]: {
        title: 'Oops. Not enough coins!',
        template: '#depositMoney'
    },
    [ERROR_INSUFFICIENT_LEVEL]: {
        title: 'insufficient level',
        template: '#insufficientLevel'
    },
    [ERROR_NEED_SURROUND]: {
        title: 'Not enough influence',
        template: '#needSurround'
    }
}

